import { ApiRecent, ApiRecentUpdate } from "@/types/recents/recents.types";
import { api } from "./axios";

export const apiRecent = {
  getAll: () => {
    return api.get<ApiRecent>("/api/v1/recent");
  },
  update: (payload: ApiRecentUpdate) => {
    return api.post<void>("/api/v1/recent", payload);
  },
};
